export const FEATURE_ROUTE_ONBOARD = '/onboard';
export const FEATURE_ROUTE_DASHBOARD = '/dashboard';
export const FEATURE_ROUTE_PRODUCTS = '/products';
export const FEATURE_ROUTE_CUSTOMERS = '/customers';
export const FEATURE_ROUTE_SCAN = '/scan';
export const ADDON_MARKETPLACE = '/settings/addonmarketplace';
export const FEATURE_ROUTE_HOME = '/home';
export const FEATURE_ROUTE_FULFILLMENTS = '/fulfillments';
export const FEATURE_ROUTE_AUTOMATIONS = '/automations';
export const FEATURE_ROUTE_SUPPLIES = '/supplies';
export const FEATURE_ROUTE_FREIGHT = '/freight/ltl';
